import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  SlidersHorizontal, 
  CreditCard, 
  Calendar, 
  ShoppingBag, 
  ArrowLeft, 
  ChevronRight,
  Settings2,
  DollarSign
} from 'lucide-react';

/**
 * Card de Configuración Técnica - Diseño Enterprise
 */
const ConfigCard = ({ icon: Icon, title, desc, color, onClick }) => (
  <div 
    onClick={onClick} 
    className="group bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:border-[#51A7FD] hover:shadow-md transition-all cursor-pointer relative overflow-hidden"
  >
    {/* Indicador lateral de color dinámico */}
    <div className="absolute left-0 top-0 bottom-0 w-1" style={{ backgroundColor: color }}></div>
    
    <div className="flex items-start gap-4">
      <div className="p-3 rounded-xl bg-slate-50 transition-colors shrink-0 group-hover:bg-blue-50" style={{ color: color }}>
        <Icon size={20} />
      </div>
      <div className="min-w-0 pr-4">
        <h3 className="text-[11px] font-bold text-slate-800 mb-1 uppercase tracking-widest group-hover:text-[#51A7FD] transition-colors">
          {title}
        </h3>
        <p className="text-[10px] text-slate-400 font-medium leading-relaxed italic">
          {desc}
        </p>
      </div>
    </div>
    
    <div className="absolute right-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all">
      <ChevronRight size={16} className="text-[#51A7FD]" />
    </div>
  </div>
);

function ConfigVentas() {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-[#F8FAFC] font-sans text-slate-700 p-4 md:p-6 lg:p-8">
      
      {/* HEADER TÉCNICO */}
      <header className="flex items-center gap-4 mb-10 px-2">
        <button 
          onClick={() => navigate('/sistema/configuracion')}
          className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-[#51A7FD] transition-all shadow-sm"
        >
          <ArrowLeft size={20} />
        </button>
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-slate-800 uppercase tracking-tight leading-none">Ventas y Cobros</h1>
          <p className="text-[10px] font-medium text-slate-400 uppercase tracking-widest mt-2 italic">Configuración de terminales de pago y parámetros comerciales</p>
        </div>
      </header>

      <div className="max-w-[1400px] mx-auto animate-nova-in">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <ConfigCard 
            icon={SlidersHorizontal} 
            title="Predeterminados Venta" 
            desc="Asignación de cliente por defecto y lista de precios base para terminales rápidas." 
            color="#10b981" 
            onClick={() => navigate('/sistema/configuracion/ventas/predeterminados')} 
          />
          <ConfigCard 
            icon={CreditCard} 
            title="Métodos de Cobro" 
            desc="Gestión de pasarelas: Efectivo, Tarjetas, Bancos y protocolos de recargo automático." 
            color="#f59e0b" 
            onClick={() => navigate('/sistema/configuracion/ventas/cobros')} 
          />
          <ConfigCard 
            icon={Calendar} 
            title="Condiciones de Pago" 
            desc="Definición de plazos, gestión de cuentas corrientes y alertas de vencimientos." 
            color="#3b82f6" 
            onClick={() => navigate('/sistema/configuracion/ventas/condiciones')} 
          />
          <ConfigCard 
            icon={ShoppingBag} 
            title="Tienda Online" 
            desc="Parámetros del catálogo público, URL de despacho y experiencia de e-commerce." 
            color="#ec4899" 
            onClick={() => navigate('/sistema/configuracion/ventas/tienda')} 
          />
        </div>
      </div>

      <style>{`
        .animate-nova-in { animation: novaFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        @keyframes novaFadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}

export default ConfigVentas;